export const INITIAL_IMAGE_DATA = "INITIAL_IMAGE_DATA";
export const SAVE_IMAGE_DATA = "SAVE_IMAGE_DATA";
